import Box from '@mui/material/Box';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { ThemeTypography } from '../common/ThemeTypography';
import { theme } from '../../configs/theme';
import { FortnoxImportRun } from '../../models/FortnoxImportRun';
import { fortnoxImportPhases } from '../../utils/fortnoxImportRun';

type Props = {
  run: FortnoxImportRun;
};

/**
 * One line per phase of an import (Kunder, Artiklar, Fakturor), so people can see when
 * customers and articles are in and they can start working, while invoices still arrive.
 */
export const FortnoxImportPhases = ({ run }: Props) => (
  <Box
    component="dl"
    sx={{
      display: 'grid',
      gridTemplateColumns: 'max-content 1fr',
      columnGap: '12px',
      rowGap: '2px',
      margin: 0,
      alignItems: 'center',
    }}
    data-testid="fortnox-import-phases"
  >
    {fortnoxImportPhases(run).map((phase) => (
      <Box key={phase.key} sx={{ display: 'contents' }}>
        <ThemeTypography component="dt" type="body2" sx={{ margin: 0, fontWeight: 600 }}>
          {phase.label}
        </ThemeTypography>
        <Box component="dd" sx={{ margin: 0, display: 'flex', alignItems: 'center', gap: '4px' }}>
          {phase.state === 'done' && (
            <CheckCircleIcon
              sx={{ fontSize: 16, color: theme.palette.customColors.emerald }}
              aria-hidden
            />
          )}
          <ThemeTypography type="body2" sx={{ margin: 0 }}>
            {phase.text}
          </ThemeTypography>
        </Box>
      </Box>
    ))}
  </Box>
);
